import DayPage from './Day/HydrationDayPage';
import { PATH_HYDRATION } from './paths';

const routes = [
    {
        path: PATH_HYDRATION,
        component: DayPage,
        private: true,
        exact: true,
        title: 'route-title/hydration-day',
        mobileAppTabIdentifier: 'more',
    },
];

export { routes };
